export default __webpack_public_path__ + "static/media/ast-1094363.6c47f1a7.jpg";